var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotationMarksPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 27,
    viewBox: "0 0 40 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x80\x9C",
    filter: "url(#filter0_d_5751_72486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4551 2.11125C32.0899 2.88947 31.7552 3.72328 31.4509 4.61267C31.2075 5.44647 31.0553 6.28028 30.9944 7.11408C30.9944 7.8923 31.1466 8.61493 31.4509 9.28198C31.7552 9.89344 32.3029 10.3937 33.0941 10.7828C34.6765 11.561 36.0154 12.5616 37.1109 13.7845C38.2672 14.9519 38.8454 16.3971 38.8454 18.1203C38.8454 19.1765 38.6324 20.177 38.2064 21.122C37.7803 22.067 37.1717 22.9008 36.3806 23.6234C35.6502 24.2905 34.7678 24.8186 33.7331 25.2077C32.6985 25.5968 31.603 25.7913 30.4467 25.7913C28.134 25.7913 26.1865 25.0409 24.6042 23.5401C23.0218 22.0392 22.1698 20.2326 22.048 18.1203C21.8655 15.8968 22.1698 13.8401 22.9609 11.9502C23.813 10.0046 24.7867 8.30921 25.8822 6.86394C27.0386 5.41868 28.1645 4.25135 29.2599 3.36196C30.3554 2.41698 31.1162 1.80552 31.5422 1.52759C31.6639 1.58317 31.8161 1.66656 31.9986 1.77773L32.2725 2.02787C32.3334 2.08346 32.3942 2.11125 32.4551 2.11125ZM11.4584 2.11125C11.0932 2.88947 10.7585 3.72328 10.4542 4.61267C10.2108 5.44647 10.0586 6.28028 9.99776 7.11408C9.99776 7.8923 10.1499 8.61493 10.4542 9.28198C10.7585 9.89344 11.3063 10.3937 12.0974 10.7828C13.6798 11.561 15.0187 12.5616 16.1142 13.7845C17.2705 14.9519 17.8487 16.3971 17.8487 18.1203C17.8487 19.1765 17.6357 20.177 17.2097 21.122C16.7836 22.067 16.175 22.9008 15.3839 23.6234C14.6536 24.2905 13.7711 24.8186 12.7365 25.2077C11.7018 25.5968 10.6064 25.7913 9.45002 25.7913C7.13735 25.7913 5.18983 25.0409 3.60747 23.5401C2.02511 22.0392 1.17307 20.2326 1.05135 18.1203C0.868771 15.8968 1.17307 13.8401 1.96425 11.9502C2.81629 10.0046 3.79005 8.30921 4.88553 6.86394C6.04187 5.41868 7.16778 4.25135 8.26326 3.36196C9.35873 2.41698 10.1195 1.80552 10.5455 1.52759C10.6672 1.58317 10.8194 1.66656 11.002 1.77773L11.2758 2.02787C11.3367 2.08346 11.3975 2.11125 11.4584 2.11125Z",
    fill: "#51459E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5751_72486",
    x: 0,
    y: 0.527588,
    width: 39.8455,
    height: 26.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5751_72486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5751_72486",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMarksPurple);
export default __webpack_public_path__ + "static/media/quotation-marks-purple.61635785006d8332be2a689fedd3937c.svg";
export { ForwardRef as ReactComponent };